module.exports = {"title":"Terminal","body":"<p class=\"edit-page\"><a href=\"https://github.com/alex285/myGNOME/blob/master/pages/docs/terminal/index.md\">Edit on Github</a></p>\n<div class=\"clear\"></div>\n<p>Theres nothing here to see yet!</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./docs/terminal/index.md
 ** module id = 537
 ** module chunks = 0
 **/